<template>
    <slot v-if="shouldShow"></slot>
</template>

<script>
import authService from '@/services/authService';

export default {
    name: 'FeatureFlag',
    props: {
        feature: String,
        defaultEnabled: {
            type: Boolean,
            default: false
        },
        roles: {
            type: [String, Array],
            default: null
        },
        testUsers: Boolean
    },
    computed: {
        shouldShow() {
            const hasFeatureAccess = this.feature ? this.isFeatureEnabled(this.feature) : true;
            const hasTesterAccess = this.testUsers ? authService.isTester() : true;

            let hasRoleAccess = true;
            if (this.roles) {
                if (typeof this.roles === 'string') {
                    hasRoleAccess = authService.hasRole(this.roles);
                }
                if (Array.isArray(this.roles)) {
                    hasRoleAccess = this.roles.some(role => authService.hasRole(role));
                }
            }

            return hasFeatureAccess && hasTesterAccess && hasRoleAccess;
        }
    },
    methods: {
        normalizeFeatureName(feature) {
            if (feature.startsWith('VUE_APP_')) {
                return feature;
            }

            return `VUE_APP_FEATURE_${feature.toUpperCase().replace(/[^A-Z0-9]+/g, '_')}`;
        },
        isFeatureEnabled(feature) {
            const envKey = this.normalizeFeatureName(feature);
            const rawValue = process.env[envKey];

            if (typeof rawValue === 'boolean') {
                return rawValue;
            }

            if (rawValue == null) {
                return this.defaultEnabled;
            }

            return ['1', 'true', 'yes', 'on'].includes(String(rawValue).trim().toLowerCase());
        }
    }
}
</script>
